import { Component, computed, effect, inject, signal } from '@angular/core';
import { NotificationsService } from '../../../../notifications/services/notifications.service';
import { Notifications } from '../../../../notifications/models/notification';

import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { NotificationDataService } from '../../../../notifications/services/notifications.data.service';
import { OneSignal } from 'onesignal-ngx';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../../../../auth/services/auth.service';
import { UserDataService } from '../../../services/user-data.service';

@Component({
  selector: 'notifications-nav',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './notifications-nav.component.html',
  styles: ``
})
export class NotificationsNavComponent {
  private oneSignal = inject(OneSignal);
  private notificationService = inject(NotificationsService)  
  private router = inject(Router)
  private userDataService = inject(UserDataService);
  public notificationDataService = inject(NotificationDataService)

  public showAlert = computed(() => this.notificationDataService.notifications().length > 0);
  public alertsCount = computed(() => this.notificationDataService.notifications().length);  

  constructor(){
    effect(() => {
      const data = this.userDataService.userData();               

      this.setOneSignal();
    });
  }


   ngOnInit(){                        
    this.notificationService.getNotifications().subscribe({
      next: (response) => {
        this.notificationDataService.setNotifications(response);
      }
    })  
  }

  isUserLoggedIn(): boolean {
    return !!this.oneSignal.User.externalId;
  }

  async setOneSignal(){
    if(this.isUserLoggedIn()){
      return;
    }    
    await this.oneSignal.login(this.userDataService.userData()?.userId!);    

    this.oneSignal.Notifications.addEventListener('foregroundWillDisplay', (event) => {    
      
      const notification: Notifications = {
        notificationId: event.notification.notificationId,
        title: event.notification.title!,
        message: event.notification.body,
        redirectScreen: (event.notification.additionalData as any)?.screen || '' ,
        creationDate: new Date(),
      };

      this.notificationDataService.addNotification(notification);
    });     
  }

  read(notification: Notifications){    
    if(!notification){
      return;
    }

    this.notificationService.markAsRead(notification.notificationId).subscribe({      
      next: () =>{
          this.notificationDataService.removeNotification(notification);                    
          const url = notification.redirectScreen;

          if (url?.startsWith('http://') || url?.startsWith('https://')) {
            window.open(url, '_blank');
          } else {
            this.router.navigate([url]);
          }
      }
    })

  }

}
